module.exports = __webpack_public_path__ + "static/media/0007.ff8bd56c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48106/RAL/0007.png
// module id = 2540
// module chunks = 0